import {Button} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEllipsis, faPencil, faTrashCan} from "@fortawesome/free-solid-svg-icons";
import {useState} from "react";

export default function ThreeDotMenu({onEdit, onDelete}) {
    const [open, setOpen] = useState(false);
    return (
        <div className="relative inline-block">
            <Button onClick={() => setOpen(v => !v)}>
                <FontAwesomeIcon icon={faEllipsis} size={"xl"}/>
            </Button>
            {open && (
                <div className="absolute left-0 mt-2 bg-white border rounded shadow-md w-40 z-40">
                    <Button
                        onClick={() => {
                            setOpen(false);
                            onEdit();
                        }}
                        className="w-full text-left px-3 py-2 hover:bg-gray-50 flex items-center gap-2">
                            <span className="text-black">
                                <FontAwesomeIcon icon={faPencil} size={"lg"}/>
                            </span>
                        <span>ویرایش</span>
                    </Button>
                    <Button
                        onClick={() => {
                            setOpen(false);
                            onDelete();
                        }}
                        className="w-full text-left px-3 py-2 hover:bg-gray-50 flex items-center gap-2">
                            <span className="text-red-600">
                                <FontAwesomeIcon icon={faTrashCan} size={"lg"}/>
                            </span>
                        <span>حذف</span>
                    </Button>
                </div>
            )}
        </div>
    );
}
